import 'react-multi-carousel/lib/styles.css';
import Gustavo_Davalos from '../assets/img/members/Gustavo_Davalos.jpg';
import Alejandro_Aguirre from '../assets/img/members/Alejandro_Aguirre_Diaz.png';
import Gera from "../assets/img/members/Gera.jpeg";
import Rodrigo from "../assets/img/members/Rodrigo.jpg";
import Bryan from "../assets/img/members/Bryan.jpeg";
import Kevin from "../assets/img/members/Kevin.jpeg";
import Mirel from "../assets/img/members/Mirel.jpeg"
import colorSharp from "../assets/img/color-sharp.png";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import React, { useState } from 'react';

export const Abouts = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        variableHeight: false,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 990,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 765,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    const [expandedIndex, setExpandedIndex] = useState(null);

    const toggleExpanded = (index) => {
        setExpandedIndex(expandedIndex === index ? null : index);
    };

    const renderContent = (content, index) => {
        const isExpanded = expandedIndex === index;
        const contentToShow = isExpanded ? content : content.props.children.slice(0, 3);
        const buttonText = isExpanded ? 'Collapse' : 'Read More';

        return (
            <div>
                {contentToShow}
                {content.props.children.length > 3 && <button onClick={() => toggleExpanded(index)}>{buttonText}</button>}
            </div>
        );
    };

    const [tooltipText, setTooltipText] = useState('Copy to clipboard');

    const copyToClipboard = (mail) => {
        navigator.clipboard.writeText(mail)
            .then(() => {
                setTooltipText('Copied...');
                setTimeout(function() {
                    setTooltipText('Copy to clipboard');
                }, 2000);
            })
            .catch((error) => {
                console.error('Error copying to clipboard: ', error);
            });
    }

    const data = [
        {
            name: `Rodrigo Alberto Castañeda Alfaro`,
            img: Rodrigo,
            about_text: (
                <div>
                    <p><strong>Occupation within the team:</strong> Main person in charge for mechanical and industrial design area.</p>
                    <p><strong>Residence:</strong> Zapopan, Jalisco, México.</p>
                    <p><strong>Age:</strong> 26.</p>
                    <p><a target="_blank" href="https://www.linkedin.com/in/rodrigo-a-c-alfaro/">LinkedIn</a>  <a target="_blank" href="https://www.behance.net/rodrigocastaeda3">Behance</a></p>
                    <p><strong>Email:</strong> <span className="tooltipmail" onClick={() => copyToClipboard('rodrigoalfarolevi@gmail.com')}>
                        <a className="mail">rodrigoalfarolevi@gmail.com</a>
                        <span className="tooltiptext">{tooltipText}</span>
                    </span></p>
                </div>
            )
        },
        {
            name: `Gerardo de Jesus Galindo Mejia`,
            img: Gera,
            about_text: (
                <div>
                    <p><strong>Occupation within the team:</strong> Main person in charge of the electrical mechanics area.</p>
                    <p><strong>Residence:</strong> Guadalajara, Jalisco, México.</p>
                    <p><strong>Age:</strong> 23.</p>
                    <p><a target="_blank" href="https://www.linkedin.com/in/gerardo-galindo-arcaunity/">LinkedIn</a></p>
                    <p><strong>Email:</strong> <span className="tooltipmail" onClick={() => copyToClipboard('gerardo12992@gmail.com')}>
                        <a className="mail">gerardo12992@gmail.com</a>
                        <span className="tooltiptext">{tooltipText}</span>
                    </span></p>
                </div>
            )
        },/*{
            name: `Alejandro Aguirre Díaz`,
            img: Alejandro_Aguirre,
            about_text: (
                <div>
                    <p><strong>Occupation within the team:</strong> Main person in charge of the Electronics area.</p>
                    <p><strong>Residence:</strong> Guadalajara, Jalisco, México.</p>
                    <p><strong>Age:</strong> 21.</p>
                    <p><a target="_blank" href="https://www.linkedin.com/in/alejandro-aguirre-diaz-94b871207/">LinkedIn</a></p>
                    <p><strong>Email:</strong> <span className="tooltipmail" onClick={() => copyToClipboard('duocoretablet@gmail.com')}>
                        <a className="mail">duocoretablet@gmail.com</a>
                        <span className="tooltiptext">{tooltipText}</span>
                    </span></p>
                </div>
            )
        },*/
        {
            name: `Gustavo Alejandro Dávalos Valadez`,
            img: Gustavo_Davalos,
            about_text: (
                <div>
                    <p><strong>Occupation within the team:</strong> Main person in charge of the Software Development area.</p>
                    <p><strong>Residence:</strong> Guadalajara, Jalisco, Mexico.</p>
                    <p><strong>Age:</strong> 23.</p>
                    <p><a target="_blank" href="https://www.linkedin.com/in/gustavo-davalos-5801901a2">LinkedIn</a></p>
                    <p><strong>Email:</strong> <span className="tooltipmail" onClick={() => copyToClipboard('gadavalosv@gmail.com')}>
                        <a className="mail">gadavalosv@gmail.com</a>
                        <span className="tooltiptext">{tooltipText}</span>
                    </span></p>
                </div>
            )
        },
        {
            name: `Bryan Alexis Romo Ramírez`,
            img: Bryan,
            about_text: (
                <div>
                    <p><strong>Occupation within the team:</strong> Main person in charge of Marketing and software development.</p>
                    <p><strong>Residence:</strong> Zapopan, Jalisco, México.</p>
                    <p><strong>Age:</strong> 22.</p>
                    <p><a target="_blank" href="https://www.linkedin.com/in/bryan-romo-60b700263">LinkedIn</a></p>
                    <p><strong>Email:</strong> <span className="tooltipmail" onClick={() => copyToClipboard('bryanromo2001@gmail.com')}>
                        <a className="mail">bryanromo2001@gmail.com</a>
                        <span className="tooltiptext">{tooltipText}</span>
                    </span></p>
                </div>
            )
        },{
            name: `Kevin Hau Leal`,
            img: Kevin,
            about_text: (
                <div>
                    <p><strong>Occupation within the team:</strong> Main person in charge of the Chemistry area.</p>
                    <p><strong>Residence:</strong> Guadalajara, Jalisco, Mexico.</p>
                    <p><strong>Age:</strong> 23.</p>
                    <p><strong>Email:</strong> <span className="tooltipmail" onClick={() => copyToClipboard('kevinhau100@gmail.com')}>
                        <a className="mail">kevinhau100@gmail.com</a>
                        <span className="tooltiptext">{tooltipText}</span>
                    </span></p>
                </div>
            )
        }/*,{
            name: `Mirel Isaac Larios Balero`,
            img: Mirel,
            about_text: (
                <div>
                    <p><strong>Occupation within the team:</strong> Member of the Electronics area and artist of the advertising area.</p>
                    <p><strong>Residence:</strong> Guadalajara, Jalisco, México.</p>
                    <p><strong>Age:</strong> 22.</p>
                    <p><a target="_blank" href="https://www.linkedin.com/in/mirel-isaac-larios-balero-b68108272">LinkedIn</a></p>
                    <p><strong>Email:</strong> <span className="tooltipmail" onClick={() => copyToClipboard('mirellarios1001@gmail.com')}>
                        <a className="mail">mirellarios1001@gmail.com</a>
                        <span className="tooltiptext">{tooltipText}</span>
                    </span></p>
                </div>
            )
        } */  
    ];

    return (
        <section className="about" id="abouts">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="about-bx wow zoomIn">
                            <h2>About Us</h2>
                            <p className="aboutP">Allow us to introduce our team and provide a brief overview of our respective areas of expertise.<br></br> For further details, we invite you to explore our individual profiles on LinkedIn.</p>
                            <Slider className='about-slider' {...settings}>
                                {data.map((d, index) => (
                                    <div key={d.name} className={`about-card text-black rounded-2xl ${expandedIndex === index ? 'expanded' : ''}`}>
                                        <div className='h-56 flex justify-center items-center rounded-t-xl'>
                                            <img src={d.img} alt="" className="h-44 w-44 rounded-full hover:rounded-3xl"/>
                                        </div>

                                        <div className="flex flex-col items-center justify-center gap-px px-2 py-3">
                                            <p className="text-black text-xl font-semibold">{d.name}</p>
                                            <div className="text-black text-center">{renderContent(d.about_text, index)}</div>
                                        </div>
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </div>
                </div>
            </div>
            {/* <img className="background-image-left" src={colorSharp} alt="Image" /> */}
        </section>
    )
}